// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  repoConnectionId: __t.u64().primaryKey().name("repo_connection_id"),
  workspaceId: __t.u64().name("workspace_id"),
  githubOwner: __t.string().name("github_owner"),
  githubRepo: __t.string().name("github_repo"),
  defaultBranch: __t.string().name("default_branch"),
  connectedAt: __t.i64().name("connected_at"),
});
